// Page-level content for the Pro checkout flow. Components are layout-only;
// copy and per-plan data live here so prices/copy can be edited without
// touching markup.
export const DEFAULT_PLAN = () => 'yearly';
// Features unlocked on success — shown as a checklist on the success screen.
// Mirrors the "Pro" tier feature list on the pricing page.
export const PRO_FEATURES = [
    'Unlimited property pages',
    'Public, private, and unlisted pages',
    'Full participation in community discussions',
    'Ad-free experience',
    'Email support',
];
// Interstitial shown to anonymous visitors before the checkout flow. Frames
// the account requirement around what the user *gets* (their subscription
// stays with them) rather than what we need from them.
export const AUTH_GATE_COPY = {
    headline: "Protect and preserve your property's story",
    body: 'Create your free 76UNBOXED account to securely preserve your property history and records — all in one place.',
    ctaLabel: 'Create My Free Account',
    footnote: 'No payment required to sign up.',
};
// Setup-screen page header copy.
export const SETUP_COPY = {
    headline: 'Get 76Pro',
    subhead: "Document your home's full story. Cancel anytime.",
};
